export default class Time {
  static format(fmt, date) {
    let reg = '';
    const opt = {
      'y+': date.getFullYear().toString(), // 年
      'M+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'H+': date.getHours().toString(), // 时
      'm+': date.getMinutes().toString(), // 分
      's+': date.getSeconds().toString(), // 秒
    };

    for (let k in opt) {
      reg = new RegExp('(' + k + ')').exec(fmt);
      if (reg) {
        fmt = fmt.replace(reg[1], reg[1].length == 1 ? opt[k] : opt[k].padStart(reg[1].length, '0'));
      }
    }
    return fmt;
  }

  static getWeek(date) {
    const chineseDays = {
      0: "星期日",
      1: "星期一",
      2: "星期二",
      3: "星期三",
      4: "星期四",
      5: "星期五",
      6: "星期六"
    };
    
    // 星期几的英文映射对象
    const englishDays = {
      0: "Sunday",
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday"
    };

    let day = date.getDay();
    return englishDays[day];
  }
}
